import React from "react";
import Avatar from "../Avatar";
import MessageDate from "./MessageDate";
import S from "./Message.styled";
import AugmentedMessage from "./AugmentedMessage";
import MessageFile from "./MessageFile";
const MessageWithAvatar = ({ message, status, editableMessageId, setEditableMessageId, }) => {
    const { sender } = message;
    return (React.createElement(React.Fragment, null,
        React.createElement(Avatar, { src: sender === null || sender === void 0 ? void 0 : sender.image, alt: sender.name }),
        React.createElement(S.Gutter, { size: "small" },
            React.createElement(S.Header, null,
                React.createElement(S.Sender, null, sender.name),
                React.createElement(MessageDate, { date: new Date(message.date) })),
            React.createElement(AugmentedMessage, { status: status, message: message, editableMessageId: editableMessageId, setEditableMessageId: setEditableMessageId }),
            message.fileToken ? React.createElement(MessageFile, { token: message.fileToken }) : null)));
};
export default MessageWithAvatar;
//# sourceMappingURL=MessageWithAvatar.js.map